import { mmFetchWithResponse } from 'api/mmFetchWithResponse';

const COMPANY_SOURCE_TRANSFERS_BASE = 'api/inventory/v1/company-source-transfers';

const companySourceTransfersApi = {
    /**
     * Transfers inventory at a location from one company source to another.
     *
     * @param {Object} params
     * @param {number} params.sourceLotId
     * @param {number} params.destinationCompanySourceId
     * @param {number} params.locationId
     * @param {Array<{ palletId?: number | string, numCases: number, numLooseUnits: number }>} params.selectedInventory
     * @returns {Promise<{status: boolean, msg: string, data: any}>}
     */
    createCompanySourceTransfer: async ({ destinationCompanySourceId, locationId, selectedInventory, sourceLotId }) =>
        mmFetchWithResponse(COMPANY_SOURCE_TRANSFERS_BASE, {
            method: 'POST',
            body: JSON.stringify({
                sourceLotId,
                destinationCompanySourceId,
                locationId,
                selectedInventory,
            }),
        }),
};

export { companySourceTransfersApi };
